import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Accordion, Button, Card, Table } from "react-bootstrap";

interface ProductInformationProps{
  productInformation: string | null;
  templateValues: {[key: string]: string} | null;
}

const ProductInformation: React.FC<ProductInformationProps> = ({productInformation, templateValues}) => {
  return (
    <Accordion defaultActiveKey="0" className="mb-3">
      {/* Product Information */}
      <Card>
        <Card.Header className="product-information-header">
          <Accordion.Toggle as={Button} variant="link" eventKey="0" className="product-accordion-title">
            Product Information
            <FontAwesomeIcon icon={faChevronDown} />
          </Accordion.Toggle>
        </Card.Header>
        <Accordion.Collapse eventKey="0">
          <Card.Body className="row justify-content-center">
            {productInformation && (
              <div className={`${templateValues ? 'col-12 col-md-6 mb-3 mb-md-0' : 'col-12'}`}>
                {productInformation}
              </div>
            )}
            {templateValues && (
              <div className={`${productInformation ? 'col-12 col-md-6' : 'col-md-6'}`}>
                <Table bordered striped>
                  <tbody>
                    {Object.entries(templateValues).map(([key, value]) => (
                      <tr key={key}>
                        <th>{key}</th>
                        <td>{value}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
}

export default ProductInformation;